import { render, staticRenderFns } from "./AddNPPage.vue?vue&type=template&id=3f568e38&scoped=true&"
import script from "./AddNPPage.vue?vue&type=script&lang=js&"
export * from "./AddNPPage.vue?vue&type=script&lang=js&"
import style0 from "./AddNPPage.vue?vue&type=style&index=0&id=3f568e38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f568e38",
  null
  
)

export default component.exports